import http from './httpService';
import { LIVE } from '../api/yugeAPI2';

export default function getProduct(productId) {
  const data = {
    live: LIVE,
  };
  return http.get(`/products/${productId}`, data);
}
